<template>
  <TestingPage
    v-if="quiz && questions.length"
    :quiz="quiz"
    :questions="questions"
    :current-index="currentIndex"
    :answers="answers"
    :locked="locked"
    @select-option="onSelect"
  />
  <div v-else class="loading-screen">
    <div class="spinner" />
  </div>
</template>

<script>
import TestingPage from '../components/TestingPage.vue'
import { quizStore } from '../store/quiz'

export default {
  name: 'QuizTestingView',
  components: { TestingPage },
  props: { id: { type: [String, Number], required: true } },
  data () {
    return {
      locked: false,
      advanceTimer: null
    }
  },
  computed: {
    quiz () { return quizStore.getState().quiz },
    questions () { return quizStore.getState().questions },
    currentIndex () { return quizStore.getState().currentIndex },
    answers () { return quizStore.getState().answers }
  },
  created () {
    if (!this.quiz || String(quizStore.getState().quizId) !== String(this.id)) {
      this.$router.replace({ name: 'QuizLanding', params: { id: this.id } })
    }
  },
  beforeDestroy () {
    if (this.advanceTimer) clearTimeout(this.advanceTimer)
  },
  methods: {
    onSelect (questionId, optionId) {
      if (this.locked) return

      const state = quizStore.getState()
      const current = state.questions[state.currentIndex]
      if (!current || String(current.id) !== String(questionId)) return

      quizStore.setAnswer(questionId, optionId)
      this.locked = true

      const isLast = state.currentIndex >= state.questions.length - 1
      if (isLast) {
        this.$router.push({ name: 'QuizBuffering', params: { id: this.id } })
        return
      }

      if (this.advanceTimer) clearTimeout(this.advanceTimer)
      this.advanceTimer = setTimeout(() => {
        quizStore.nextQuestion()
        this.locked = false
        this.advanceTimer = null
      }, 280)
    }
  }
}
</script>
